let sharedEnv = null;
import { BehaviorSubject } from 'rxjs';

const hasSharedEnv = new BehaviorSubject<boolean>(false);
function shareEnv (env: Object) {
  sharedEnv = env;
  hasSharedEnv.next(true);
}

export { sharedEnv, shareEnv, hasSharedEnv };